import React, { useEffect } from "react";
import { useNavigate } from "react-router";
import { useUser } from "contexts/user";
import { useTranslation } from "react-i18next";
import AuthLayout from "layouts/AuthLayout";
import Alert from "components/Alert";
import Button from "components/Button";
import ProfileMenu from "features/User/ProfileMenu";
import { getLocalAuthHeader, userApi } from "api-client";
import useToast from "hooks/useToast";
import InitialLoading from "./InitialLoading";
import { userStore } from "store/UserStore";
import { observer } from "mobx-react-lite";
import { ROUTES_ENUM } from "routes/consts";

const Verify = () => {
  const navigate = useNavigate();
  const { user } = useUser();
  const { userProfile, verified } = userStore;
  const { t } = useTranslation();
  const toast = useToast();

  useEffect(() => {
    if (!verified) return;
    return navigate(`/${ROUTES_ENUM.ONBOARDING}`, { replace: true });
  }, [verified, userProfile]);

  const resendVerification = async () => {
    const authHeader = getLocalAuthHeader();
    if (authHeader) {
      try {
        const response =
          await userApi.concularApiV1RoutersUserResendVerificationEmail(
            authHeader
          );
        if (response.status === 200) {
          toast(
            t("onboarding.verifyEmailButtonSuccess", {
              mail_address: user?.email,
            }),
            "success"
          );
        }
      } catch (err: unknown) {
        console.error(err);
        toast(t("onboarding.verifyEmailButtonError"), "warning");
      }
    }
  };

  if (verified === undefined) return <InitialLoading />;
  return (
    <AuthLayout showLogout>
      <div className="mx-auto max-w-[600px] sm:px">
        <Alert
          type="info"
          title={t("onboarding.verifyEmailTitle")}
          className="mx-auto pb-8 mb-8"
        >
          <div className="text-sm">
            {t("onboarding.verifyEmailMessage", { email: user?.email })}
          </div>
        </Alert>

        <Button
          type="gray"
          width="fit-content"
          className="mx-auto"
          onClick={resendVerification}
        >
          {t("onboarding.verifyEmailButton")}
        </Button>
      </div>
    </AuthLayout>
  );
};

export default observer(Verify);
